import React, { useMemo } from 'react';
import SelectSingle from './SelectSingle';
import { PeriodType } from '../../api';
import { PeriodTypeToString } from '../Sessions/SessionPeriods';

interface Props {
  value?: PeriodType;
  periods: Array<PeriodType>;
  onChange: (period: PeriodType) => void;
}

const sortOrder = {
  [PeriodType.FirstHalf]: 0,
  [PeriodType.SecondHalf]: 1,
  [PeriodType.ExtraTimeFirstHalf]: 2,
  [PeriodType.ExtraTimeSecondHalf]: 3,
  [PeriodType.Penalties]: 4,
  [PeriodType.Other]: 5,
};

type TPeriodType = { type: PeriodType };

const SelectSinglePeriod: React.FunctionComponent<Props> = (props) => {
  const onChange = (value: TPeriodType | undefined) => {
    if (value) props.onChange(value.type);
  };

  const options = useMemo(() => {
    return props.periods
      .sort((a, b) => sortOrder[a] - sortOrder[b])
      .map((p) => {
        return { type: p };
      });
  }, [props.periods]);

  const selected = options.find((o) => o.type === props.value);

  return (
    <SelectSingle<TPeriodType>
      margin={0}
      selected={selected}
      onChange={onChange}
      data={options}
      isClearable={false}
      label="Period"
      placeholder="Select period"
      optionValue={(option) => option.type}
      optionLabel={(option) => PeriodTypeToString(option.type)}
    />
  );
};

export default SelectSinglePeriod;
